"use strict";
module.exports = function (config, get, post) {
  return {
    create: (itemModelId, params) =>
      post("/v2/item/create", { itemModelId, params }),

    update: (itemId, update) => post("/v2/item/update", { itemId, update }),

    replace: (removeId, addId) => post("/v2/item/replace", { removeId, addId }),

    destroy: (itemId) => post("/v2/item/delete", { itemId }),

    items: (query, pagination) => get("/v2/item/items", { query, pagination }),

    models: (query, pagination) =>
      get("/v2/item/models", { query, pagination }),

    classes: () => get("/v2/item/classes", {}),

    makes: () => get("/v2/item/makes", {}),

    model: {
      create: (itemSchema, make, modelName, modelNumber) =>
        post("/v2/item/model/create", {
          itemSchema,
          make,
          modelName,
          modelNumber,
        }),

      udpate: (itemModelId, update) =>
        post("/v2/item/model/update", { itemModelId, update }),

      destroy: (itemModelId) => post("/v2/item/model/delete", { itemModelId }),
    },
  };
};
